module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.config) ? _c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', [_c('v-card', {
    attrs: {
      "color": "grey lighten-4",
      "flat": "",
      "tile": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "orange lighten-4",
      "dense": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "nudge-width": 100
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-toolbar-title', _vm._g({}, on), [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$route.params.app)))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "light": ""
          }
        }, [_vm._v("arrow_drop_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.apps), function(app) {
    return _c('v-list-item', {
      key: app,
      nativeOn: {
        "click": function($event) {
          return _vm.switchApp(app)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm._f("capitalize")(app)))])], 1)
  }), 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1), _vm._v(" "), (_vm.$route.params.app === 'consumer') ? _c('div', [_c('isrs-texts-dialog', {
    attrs: {
      "baseUrl": _vm.baseUrl,
      "texts": _vm.config.texts || {}
    },
    on: {
      "saveTexts": function (texts) { return _vm.saveTexts(texts); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.app === 'mail') ? _c('div', [_c('isrs-mail-texts-dialog', {
    attrs: {
      "baseUrl": _vm.baseUrl,
      "texts": _vm.config.mailTexts
    },
    on: {
      "saveMailTexts": function (texts) { return _vm.saveMailTexts(texts); }
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-cc0c31f2"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/Texts.vue
// module id = 953
// module chunks = 1